import propTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

const LogoMPointConvertAirplane = ({width, height, ...props}) => (
  <Box
    as="svg"
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line y1="12" x2="13" y2="12" stroke="black" strokeDasharray="2 2 4" />
    <path
      d="M20 22L22 22L27 14L32.5 14C33.33 14 34 13.33 34 12.5C34 11.67 33.33 11 32.5 11L27 11L22 3L20 3L22.5 11L17 11L15.5 9L14 9L15 12.5L14 16L15.5 16L17 14L22.5 14L20 22Z"
      fill="black"
    />
    <line
      x1="36"
      y1="12"
      x2="48"
      y2="12"
      stroke="black"
      strokeDasharray="2 2 4"
    />
  </Box>
)

LogoMPointConvertAirplane.defaultProps = {
  width: '100%',
  height: '100%',
}

LogoMPointConvertAirplane.propTypes = {
  width: propTypes.string,
  height: propTypes.string,
}

export default LogoMPointConvertAirplane
